<script setup lang="ts">
// The label row above every filter control: the label text plus an
// optional "ⓘ" description toggletip.
//
// The text and the info button are siblings, never nested: a button
// inside a `<label>` is invalid (it's a labelable element) and can
// steal the label's association from the real control. When the
// control has an id (`forId`), the text is a real `<label for>` so a
// click on it still focuses the control; group controls (date range,
// multiselect, pills) pass `labelId` and point `aria-labelledby` at
// it instead. Either way the accessible name is the label text alone.

import InfoTip from "./InfoTip.vue";

defineProps<{
  label?: string;
  description?: string;
  /** Id of the single control this labels. */
  forId?: string;
  /** Id to put on the text, for `aria-labelledby`. */
  labelId?: string;
}>();
</script>

<template>
  <span class="control-label">
    <label v-if="label && forId" :id="labelId" :for="forId" class="control-label-text">{{ label }}</label>
    <span v-else-if="label" :id="labelId" class="control-label-text">{{ label }}</span>
    <InfoTip v-if="description" :text="description" :label="label" />
  </span>
</template>

<style scoped>
.control-label {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  min-width: 0;
}
.control-label-text {
  min-width: 0;
  overflow-wrap: anywhere;
}
</style>
